export const apiConfig = {
  // 独立维护 chat 模块的 baseURL
  baseUrl:'https://appv3-api.ynhdkc.com/ai-agent',
  conversationsEndpoint: '/spectra/conversations',
  createConversationEndpoint: '/spectra/conversations/create',
  messagesEndpoint: '/spectra/conversations/{conversation_id}/messages',
  defaultPageSize: 10,
  useMock: false, // 融合方案中默认为 false，走真实接口
}

export const getToken = (config) => {
  let data = localStorage.getItem('authtoken')
  if (!data) {
    return config
  }
  let authtoken = window.JSON.parse(data)
  authtoken = authtoken?.data
  return authtoken
}
